import { mutationTypes } from '@/core/constants'
import store from '@/core/store'
import timezone from 'moment-timezone'

class SetFusoHorarioListener {
	async execute() {
		return new Promise((resolve) => {
			const fusoHorario = timezone.tz.guess()
			store.commit(mutationTypes.LOKI.SET_TIMEZONE, fusoHorario)
			timezone.tz.setDefault(fusoHorario)
			timezone.locale('pt')
			resolve()
		})
	}
}

export default new SetFusoHorarioListener()
